{
  "en": {
    "voiceRecorder": {
      "hints": {
        "transcribing": "Transcribing audio..."
      }
    }
  }
}
